import { createAsyncAction } from 'typesafe-actions';
import { CreatorsListDto } from '~/models/creatorsList.dto';

enum CREATORS_LIST_ACTION_TYPE {
    CREATORS_LIST_REQUEST = '@creatorsList/CREATORS_LIST_REQUEST',
    CREATORS_LIST_SUCCESS = '@creatorsList/CREATORS_LIST_SUCCESS',
    CREATORS_LIST_FAILURE = '@creatorsList/CREATORS_LIST_FAILURE',
}

export const creatorsListActions = createAsyncAction(
    CREATORS_LIST_ACTION_TYPE.CREATORS_LIST_REQUEST,
    CREATORS_LIST_ACTION_TYPE.CREATORS_LIST_SUCCESS,
    CREATORS_LIST_ACTION_TYPE.CREATORS_LIST_FAILURE
)<void, CreatorsListDto, { error: Error }>();
